var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeaViews = function SvgSeaViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.4C4.50114 13.4 4.50114 15.2182 6.99318 15.2182C9.49432 15.2182 9.49432 13.4 11.9955 13.4C14.4966 13.4 14.4966 15.2182 16.9977 15.2182C19.4989 15.2182 19.4989 13.4 22 13.4",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.2454C4.50114 17.2454 4.50114 19.0635 6.99318 19.0635C9.49432 19.0635 9.49432 17.2454 11.9955 17.2454C14.4966 17.2454 14.4966 19.0635 16.9977 19.0635C19.4989 19.0635 19.4989 17.2454 22 17.2454",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2526 14.8929C16.4461 14.3736 16.5521 13.8099 16.5521 13.2207C16.5521 10.6386 14.5161 8.54541 12.0046 8.54541C9.49303 8.54541 7.45703 10.6386 7.45703 13.2207C7.45703 13.8706 7.58601 14.4895 7.81908 15.0519",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9141 4C13.3688 4 14.7331 4.63636 14.7331 5.36364C14.7331 4.90909 15.0969 4 16.5521 4",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0068 6.72729C17.4616 6.72729 18.8258 7.36366 18.8258 8.09093C18.8258 7.63639 19.1896 6.72729 20.6449 6.72729",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSeaViews;